import React from "react";
import ReactPlayer from 'react-player';

import classes from "./Video.module.css";

const ResponsivePlayer = (props)=>{
      return (
        <div className={classes.playerWrapper}>
          <ReactPlayer
            className={classes.reactPlayer}
            url={props.url}
            width='100%'
            height='100%'
            controls={true}
          />
        </div>
      )};

export default ResponsivePlayer;